import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import appleWalletIcon from "../../../assets/icons/FR_Add_to_Apple_Wallet_RGB_102921.svg";
import googleWalletIcon from "../../../assets/icons/frFR_add_to_google_wallet_add-wallet-badge.svg";
import { theme } from "../../../constants/theme";
import { useConfig } from "../../../context/ConfigContext";
import { GoogleWalletParams } from "../../../interfaces/loyality.interface";
import { loyalityApi } from "../../../services/loyalityApi";
import { RootState } from "../../../store/rootState";
import "./AddToWallet.scss";

interface AddToWalletProps {
  compact?: boolean;
}

const AddToWallet: React.FC<AddToWalletProps> = ({ compact = false }) => {
  const { config } = useConfig();
  const { companyId } = config || {};
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  const primaryColor = config?.primaryColor || theme.colors.primary;
  const [addingToGoogleWallet, setAddingToGoogleWallet] = useState(false);
  const [addingToAppleWallet, setAddingToAppleWallet] = useState(false);

  const isIOS = true
  
  // /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  //   !(typeof (window as any).MSStream !== "undefined");

  const addToGoogleWallet = () => {
    setAddingToGoogleWallet(true);

    loyalityApi
      .addToGoogleWallet({
        userId: userInfo.id.toString(),
        codeFid: userInfo?.qrCodeValue,
        companyId: config?.companyId,
        firstName: userInfo?.firstName,
        lastName: userInfo?.lastName,
        email: userInfo?.email,
      } as GoogleWalletParams)
      .then((response) => {
        const saveUrl = response.data.result;
        if (saveUrl) {
          window.open(saveUrl, "_blank");
        } else {
          console.error("Failed to generate save link");
        }
      })
      .catch((error) => {
        console.error("Error adding to Google Wallet:", error);
      })
      .finally(() => {
        setAddingToGoogleWallet(false);
      });
  };

  const addToAppleWallet = async () => {
    setAddingToAppleWallet(true);
    try {
      const res = await loyalityApi.addToAppleWallet({
        userId: userInfo?.id?.toString(),
        codeFid: userInfo?.qrCodeValue,
        companyId,
        firstName: userInfo?.firstName,
        lastName: userInfo?.lastName,
        email: userInfo?.email,
      } as GoogleWalletParams);

      const passUrl = res.data.result.downloadUrl;
      if (passUrl) {
        window.location.href = passUrl;
      } else {
        console.error("Failed to generate Apple Wallet pass URL");
      }
    } catch (error) {
      console.error("Error adding to Apple Wallet:", error);
    } finally {
      setAddingToAppleWallet(false);
    }
  };

  return (
    <div className={`AddToWallet ${compact ? "compact" : ""}`}>
      {/* Apple Wallet Button */}
      {isIOS && (
        <button
          className={`wallet-btn apple-wallet ${addingToAppleWallet ? "loading" : ""}`}
          onClick={addToAppleWallet}
          disabled={addingToAppleWallet}
        >
          {addingToAppleWallet ? (
            <CircularProgress size={24} sx={{ color: primaryColor }} />
          ) : (
            <img src={appleWalletIcon} alt="Apple Wallet" />
          )}
        </button>
      )}
      {/* Google Wallet Button */}
      <button
        className={`wallet-btn ${addingToGoogleWallet ? "loading" : ""}`}
        onClick={addToGoogleWallet}
        disabled={addingToGoogleWallet}
      >
        {addingToGoogleWallet ? (
          <CircularProgress size={24} sx={{ color: primaryColor }} />
        ) : (
          <img src={googleWalletIcon} alt="Google Wallet" />
        )}
      </button>
    </div>
  );
};

export default AddToWallet;